import { render, staticRenderFns } from "./Temperatura.vue?vue&type=template&id=66c25548&"
import script from "./Temperatura.vue?vue&type=script&lang=js&"
export * from "./Temperatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports